// extracted by mini-css-extract-plugin
module.exports = {"feedCard":"feedCard_feedCard__1ITu6","posterInfo":"feedCard_posterInfo__2Z1i5","dp":"feedCard_dp__2C3Ot","name":"feedCard_name__ij8gO","content":"feedCard_content__3zyZC"};